import { Collapse, Space, Table, Typography } from "antd";

interface IToOrderListProps {
  toOrderData: any;
}

function ToOrderList({ toOrderData}: IToOrderListProps) {
  return (
    <Space direction="vertical" style={{width: '100%'}}>
      <Collapse>
        <Collapse.Panel key="to order" header="to order">
          <Space direction="vertical" style={{width: '100%'}}>
            <Table
              columns={[
                {
                  title: 'Name',
                  dataIndex: 'shortName',
                },
                {
                  title: 'Quantity',
                  dataIndex: 'quantity',
                },
                {
                  title: 'Price',
                  dataIndex: 'price',
                },
                {
                  title: 'Total',
                  dataIndex: 'total',
                }
              ]}
              dataSource={toOrderData}
            />
          </Space>
        </Collapse.Panel>
      </Collapse>
    </Space>
  )
}

export default ToOrderList;
